import { useCallback } from "react";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useAnalyticsStore } from "../../Analytics/analyticsStore";
import { registerTileUsage } from "client/Api/Workspace/workspace";
import { TileRenderState } from "../RenderState/common";

export function useRegisterTileUsage(
	renderStateIsh: Pick<TileRenderState, "data" | "dimension">
): (() => void) {
	const addAppEvent: ((data: AnalyticsAppEventData) => void) = useAnalyticsStore((x) => x.addAppEvent);

	const { data: tile, dimension } = renderStateIsh;

	return useCallback(
		(): void => {
			addAppEvent({ installedAppId: tile.environmentAppId });

			const { columnSpan } = dimension.dimension;
			const shouldRegisterUsage = columnSpan <= 2;

			if (!shouldRegisterUsage) {
				return;
			}

			registerTileUsage(tile.id)
				.catch((e) => console.error(e));
		},
		[
			addAppEvent,
			dimension.dimension,
			tile.environmentAppId,
			tile.id
		]
	);
}
